"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var BaseButton_1 = __importDefault(require("./BaseButton"));
var types_1 = require("./types");
/**
 * Our standard button component. Can also function as a link via usage of the `to` prop.
 */
var Button = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'secondary' : _b, _c = _a.backdrop, backdrop = _c === void 0 ? 'onLight' : _c, _d = _a.size, size = _d === void 0 ? types_1.ButtonSize.large : _d, disabled = _a.disabled, props = __rest(_a, ["variant", "backdrop", "size", "disabled"]);
    var theme = (0, styled_components_1.useTheme)();
    var variantStyles;
    if (backdrop === 'onLight') {
        variantStyles = disabled
            ? theme.button[variant].disabled
            : theme.button[variant].default;
    }
    else {
        variantStyles = disabled
            ? theme.button[variant].onDark.disabled
            : theme.button[variant].onDark.default;
    }
    return (react_1.default.createElement(BaseButton_1.default, __assign({ disabled: disabled, size: size }, props, { variantStyles: variantStyles })));
};
exports.Button = Button;
